// src/pages/Logout.jsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Logout() {
    const navigate = useNavigate();

    useEffect(() => {
        localStorage.removeItem('wp_jwt');
        localStorage.removeItem('wp_user');
        navigate('/login');
    }, [navigate]);

    return null;
}
